import { Card } from "react-bootstrap";
import { FaEdit, FaPlay } from "react-icons/fa";
import { IoTrashBin } from "react-icons/io5";
import { useNavigate } from "react-router-dom";
import { GameSet as GameSetModel } from "../../../models/gameSet";
import styles from "./GameSetCard.module.scss";
import { useGameStore } from "../../GamePage/stores/gameStore";
import { useTranslation } from "react-i18next";

interface GameSetCardProps {
  gameSet: GameSetModel;
  onUpdateGameSetClicked: (gameSet: GameSetModel) => void;
  onDeleteGameSetClicked: (gameSet: GameSetModel) => void;
  className?: string;
}

const GameSetCard = ({
  gameSet,
  onUpdateGameSetClicked,
  onDeleteGameSetClicked,
  className,
}: GameSetCardProps) => {
  const { title, score } = gameSet;

  const { loadNewGame } = useGameStore((state: any) => ({
    loadNewGame: state.loadNewGame,
  }));

  const navigate = useNavigate();
  const { t } = useTranslation();

  return (
    <Card className={`${styles.gameSetCard} ${className}`}>
  <Card.Body className={styles.gameSetCardBody}>
  <div className={styles.contentWrapper}>
    <Card.Title className={styles.gameSetTitle}>{title}</Card.Title>
    <Card.Text className={styles.gameSetText}></Card.Text>
  </div>

  <div className={styles.actionsWrapper}>
    <FaPlay
      className={styles.gameSetPlay}
      onClick={(e) => {
        onUpdateGameSetClicked(gameSet);
        loadNewGame(gameSet._id);
        navigate(`/gameSets/${gameSet._id}/game`);
        e.stopPropagation();
      }}
    />
    <div className={styles.iconsRight}>
      <FaEdit
        className={styles.cardIcon}
        onClick={(e) => {
          onUpdateGameSetClicked(gameSet);
          navigate(`/gameSets/${gameSet._id}`);
          e.stopPropagation();
        }}
      />
      <IoTrashBin
        className={styles.cardIcon}
        onClick={(e) => {
          onDeleteGameSetClicked(gameSet);
          e.stopPropagation();
        }}
      />
    </div>
  </div>
</Card.Body>

    </Card>
  );
};

export default GameSetCard;
